<template>
  <div class="funnel-form-component">
    <snow-input
      v-model="form.name"
      required
      label="Nome do funil"
      :errors="errors.name"
    />
    <snow-select
      v-if="isSignature"
      v-model="form.plan_id"
      required
      label="Plano"
      :loading="loadingOptions"
      :options="options"
      :errors="errors.plan_id"
    />
    <snow-select
      v-else
      v-model="form.offer_id"
      required
      label="Oferta"
      :loading="loadingOptions"
      :options="options"
      :errors="errors.offer_id"
    />

    <div class="snow-submit-buttons">
      <snow-button
        size="lg"
        text="Salvar"
        class="order-lg-1"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
      <snow-button size="lg" text="Cancelar" variant="gray" @click="close" />
    </div>
  </div>
</template>

<script>
import { clearObject, formFields } from "@/functions/helpers.js";
import { mapState } from "vuex";

export default {
  props: {
    funnel: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      funnels: [],
      ...formFields(
        [
          "id",
          "name",
          "plan_id",
          "offer_id",
          "is_end",
          "is_active",
          "product_id",
          "position_x",
          "position_y",
          "method_payment"
        ],
        {
          is_end: false,
          is_active: true,
          method_payment: "card",
          product_id: this.$route.params.id,
          position_x: parseInt(this.funnel?.position_x || 0),
          position_y: parseInt(this.funnel?.position_y || 0),
          id: this.funnel?.id,
          plan_id: this.funnel?.plan?.id,
          offer_id: this.funnel?.offer?.id,
          name: this.funnel?.name
        }
      )
    };
  },
  computed: {
    ...mapState("plan", ["plans"]),
    ...mapState("offer", ["offers"]),
    ...mapState("product", ["product"]),
    isSignature() {
      return this.product?.type_product === "signature";
    },
    options() {
      let options =
        this.product?.type_product === "signature" ? this.plans : this.offers;

      let optionsInUse = this.funnels.map(funnel => {
        return this.product?.type_product === "signature"
          ? funnel.plan.id
          : funnel.offer.id;
      });

      return options
        .filter(option => option.status == "active")
        .map(option => {
          return {
            id: option.id,
            name: option.name,
            disabled:
              optionsInUse.includes(option.id) ||
              option.id == (this.form.offer_id || this.form.plan_id)
          };
        });
    },
    isValid() {
      return (
        this.form.name &&
        this.form.product_id &&
        this.form.method_payment &&
        (this.form.plan_id || this.form.offer_id)
      );
    },
    loadingOptions() {
      return !this.options.length && !!this.form.offer_id;
    }
  },
  methods: {
    submit() {
      this.loading = true;

      const data = { ...this.form };

      let action = this.funnel ? "funnel/put" : "funnel/post";

      this.$store
        .dispatch(action, clearObject(data))
        .then(({ data }) => {
          if (!this.funnel) {
            this.$router.push({
              name: "product-funnel-tree",
              params: { id: this.$route.params.id, tree: data.tree_id }
            });
          } else this.$emit("update", data);
          this.$message.success("Salvo com sucesso");
          this.$emit("close");
        })
        .catch(error => {
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.$emit("close");
    }
  },
  mounted() {
    let action = this.isSignature ? "plan/get" : "offer/get";
    let parameters = { product_id: this.$route.params.id, limit: 50 };

    this.$store.dispatch("funnel/get", parameters).then(data => {
      this.funnels = data.data.results;
      this.$store.dispatch(action, parameters);
    });
  }
};
</script>
<style scoped lang="scss">
.funnel-form-component {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
